<template>
  <section class="section bg is-large has-background-black-lighter">
    <div class="container">
      <h1
        class="title has-text-light is-2 is-3-mobile muller-black-font is-uppercase has-text-weight-bold z"
        style="text-shadow: rgb(0, 0, 0) 2px 2px;"
      >
        Join&nbsp;the&nbsp;best
        <br />Martial Arts &
        <br />Fitness Training Academy
      </h1>
      <div class="buttons">
        <b-button
          class="is-uppercase has-text-weight-bold is-size-5 z"
          @click="isComponentModalActive = true"
        >Schedule a Free Trial</b-button>
        <whatsapp
          :title="`Schedule on Whatsapp`"
          class="is-uppercase has-text-weight-bold is-size-5 z"
        />
      </div>
    </div>
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <BookTrialModal v-bind="formProps"></BookTrialModal>
    </b-modal>
  </section>
</template>

<script>
import Whatsapp from "./Whatsapp.vue";
import BookTrialModal from "@/components/BookTrial/BookTrial-modal.vue";

export default {
  data() {
    return {
      headerImage: require("@/assets/header.jpg"),
      isComponentModalActive: false,
      formProps: {
        email: "",
        password: ""
      }
    };
  },
  components: {
    Whatsapp,
    BookTrialModal
  }
};
</script>

<style lang="scss" scoped>
.section {
  background-color: rgba(22, 22, 22, 0.548);
}
.has-background-black-lighter {
  background-color: rgba(3, 3, 3);
}
.Muller-Black {
  font-size: 3rem !important;
  font-weight: 900;
}

@media screen and (min-width: 1366px) {
  .bg {
    background-image: url("../assets/join-knockout-fight-club.jpg");
    background-repeat: no-repeat;
    background-position: right;
    // background-size: cover;
  }
}

@media screen and (max-width: 1365px) {
  .bg {
    background-image: url("../assets/join-knockout-fight-club.jpg");
    background-repeat: no-repeat;
    background-position: top;
    background-size: 100%;
  }
}

@media screen and (max-width: 1024px) {
  .bg {
    background-image: url("../assets/join-knockout-fight-club.jpg");
    background-repeat: no-repeat;
    // background-position: right;
    background-size: cover;
  }
}
</style>
